import React, { useMemo } from "react";

import { useMainStore } from "@/contexts/Store";

const CollaborativeBadge = () => {
  const mainStore = useMainStore();
  const activeWorkspace = mainStore.users.user.active_workspace;

  const collaborativeBadge = useMemo(
    () =>
      activeWorkspace && !activeWorkspace?.is_internal ? (
        <span className="collaborative-badge">Collaborative</span>
      ) : null,
    [activeWorkspace?.is_internal],
  );

  return collaborativeBadge;
};

export default CollaborativeBadge;
